import { DayActivity } from "./activity.model";

export interface IItineraryDay {
    date: string;
    activities: DayActivity[];
}

export class ItineraryDay implements IItineraryDay {
    date: string;
    activities: DayActivity[];

    constructor(data?: IItineraryDay) {
        this.date = data?.date || '';
        this.activities = data?.activities || [];
    }
}